import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import classNames from 'classnames'

import MyListButton from '../shared/my-list/my-list-button'
import TILE_FRAGMENT from '../../../graphql/fragments/tile.gql'
import {
  COMPONENT_NAME_GRID
} from '../../lib/analytics/custom-dimensions'
import styles from './grid-tile-overlay.css'

const GridTileOverlay = React.memo(({
  tile,
  display,
  isOnMyList,
  isAuthenticated,
  addToMyList
}) => {
  const onOffClass = display ? styles.tileOverlayOn : styles.tileOverlayOff
  const { contentItem, contentItem: { isRental } } = tile

  return (
    <div className={`${styles.tileOverlay} ${onOffClass}`}>
      <div className={classNames(styles.wrapper, styles.wrapperNeon, {
        [styles.wrapperNeonRental]: isRental
      })}
      >
        {isAuthenticated && (
          // Handle MyListButton on the tiles screen, such as /tv-series/comedy, /browse-movies/action
          <MyListButton
            contentItem={contentItem}
            className={styles.addMyListButton}
            isOnMyList={isOnMyList}
            addAction={addToMyList(COMPONENT_NAME_GRID)}
            isRental={isRental}
          />
        )}
      </div>
    </div>
  )
})

GridTileOverlay.propTypes = {
  tile: propType(TILE_FRAGMENT).isRequired,
  display: PropTypes.bool.isRequired,
  isOnMyList: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  addToMyList: PropTypes.func.isRequired
}

GridTileOverlay.defaultProps = {
  isOnMyList: false,
  isAuthenticated: false
}

export default GridTileOverlay
